import { Typography } from '@mui/material'
import { Box, styled } from '@mui/system'

export const Centered = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
})

interface TextProps {
  sx?: any
  children: React.ReactNode
}

export const Text = ({ sx, children }: TextProps) => {
  const StyledTypography = styled(Typography)(() => ({
    // The brand face, set once in the root layout.
    fontFamily: 'var(--font-nunito), "Space Grotesk", sans-serif',
    color: '#FFF',
    fontSize: 14,
    ...sx,
  }))

  return <StyledTypography>{children}</StyledTypography>
}

export const textStyles = {
  fontSize: '0.9rem',
  fontWeight: 500,
}
